export const getGtkmState = state => state.gtkm;
export const getGtkmAnimationState = state => getGtkmState(state).animationState;
export const getGtkmShowingErrorModal = state => getGtkmState(state).showingErrorModal;
export const getGtkmAnimationShowingCount = state => getGtkmState(state).animationShowingCount;
export const getGtkmHasDomainChangedInDomainStep = state => getGtkmState(state).hasDomainChangedInDomainStep;